/* @flow */
import Reflux from "reflux";

const CustomerHistoryAction = Reflux.createActions(["loadCatSLItems"]);

export default CustomerHistoryAction;
